/** Take in raw combatant data and provide team infrastructure */

export function buildTeamsFromCombatantData(combatants={}) {

    let result = {
        "one": {
            combatantIds: [],

        },
        "two": {
            combatantIds: [],

        }
    };

    Object.keys(combatants).forEach(combId => {
        const model = combatants[combId];

        //Add my ID to the team's list
        result[model.wantsToJoinTeam].combatantIds.push(combId);
    });



    return {...result};
}

/* Example output: //Seems funny now, but we used to include more data on here (like items). That's why it's an object.
//Can still include more in the future if needbe!
{
 "one": {
        combatantIds: ["someId_aaa", "someId_bbb"],
    },
 "two": {
        combatantIds: ["someId_ccc"],
    }
 }
 */


// WEBPACK FOOTER //
// ./src/battle/lifecycle/build-teams-from-combatant-data.js